// 파일: src/mobile_pages/notice/Notice_create.jsx
import React, { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import TinyMCEeditor from "../../components/const/TinyMCEeditor";
import { createNotice } from "../../api/meeting";

export default function NoticeCreate() {
  const navigate = useNavigate();
  const editorRef = useRef(null);
  const { id: projectId } = useParams();

  const [title, setTitle] = useState("");

  const handleSubmit = async () => {
    const context = editorRef.current ? editorRef.current.getContent() : "";

    if (!title.trim()) {
      alert("제목을 입력해주세요.");
      return;
    }

    try {
      await createNotice({
        title,
        project: projectId,
        context,
      });
      alert("공지사항이 생성되었습니다.");
      navigate(-1);
    } catch (error) {
      console.error(error);
      alert("생성에 실패했습니다.");
    }
  };

  return (
    <div className="bg-slate-50">
      <main className="mx-auto max-w-lg px-4 pt-6 pb-40">
        {/* 뒤로가기 */}
        <button
          onClick={() => navigate(-1)}
          className="mb-4 flex items-center gap-1 text-[15px] text-slate-500 active:opacity-70"
        >
          <ChevronLeft size={20} />
          목록으로
        </button>

        {/* 헤더: 제목 입력 */}
        <header className="mb-6">
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full bg-transparent text-[24px] font-bold tracking-tight text-slate-900 placeholder-slate-300 outline-none"
            placeholder="제목을 입력하세요"
          />
          <p className="mt-2 text-[14px] text-slate-400">
            새 공지사항
          </p>
        </header>

        {/* 내용 입력 영역 */}
        <section className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
          <div className="min-h-[400px] px-5 py-5">
            <TinyMCEeditor initialValue="" editorRef={editorRef} />
          </div>
        </section>

        {/* 스크롤 여유 공간 */}
        <div className="h-4" />
      </main>

      {/* 하단 액션 버튼 */}
      <footer className="fixed inset-x-0 bottom-0 border-t border-slate-200 bg-white/95 backdrop-blur-sm px-4 py-3 safe-area-bottom">
        <div className="mx-auto max-w-lg flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex-1 h-12 rounded-xl border border-slate-200 bg-white text-[15px] font-semibold text-slate-700 active:scale-[0.98] transition-transform"
          >
            취소
          </button>
          <button
            onClick={handleSubmit}
            className="flex-1 h-12 rounded-xl bg-slate-900 text-[15px] font-semibold text-white active:scale-[0.98] transition-transform"
          >
            등록
          </button>
        </div>
      </footer>
    </div>
  );
}
